var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 51,
  viewBox: "0 0 16 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 43L8 51L0 43L1.42 41.58L7 47.17V0L9 0V47.17L14.59 41.59L16 43Z",
  fill: "black"
})));
export default SvgIconDownArrow;